import {Component, OnDestroy, OnInit} from "@angular/core";
import {MatDialogRef} from "@angular/material/dialog";
import {CommonModule} from "@angular/common";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {MatButtonModule} from "@angular/material/button";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import {SessionService} from "../state/session.service";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {Client} from "../client-overview/dto/client";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'webview-component',
  template: `
    <div class="selector-row">
      <mat-form-field class="selector-field">
        <mat-label>Client</mat-label>
        <mat-select placeholder="Select Client" [(value)]="selectedClient" (selectionChange)="fetchTokenAndInitIframe()">
          <mat-option *ngFor="let client of clients" [value]="client">{{ client.name }}</mat-option>
        </mat-select>
        <mat-icon (click)="fetchTokenAndInitIframe(); $event.preventDefault(); $event.stopPropagation()" matIconSuffix>refresh</mat-icon>
      </mat-form-field>
      <mat-form-field class="selector-field">
        <mat-label>Language</mat-label>
        <mat-select placeholder="Select Language" [(value)]="selectedLanguage" (selectionChange)="fetchTokenAndInitIframe()">
          <mat-option *ngFor="let lang of languages" [value]="lang">{{ lang | uppercase }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <iframe allow="microphone" [src]="url" *ngIf="url">
    </iframe>
  `,
  styles: [`
    :host {
      width: 100%;
      height: 100%;
      display: flex;
      flex-flow: column;
      padding: 8px;
    }

    .selector-row {
      display: flex;
      flex-flow: row;
      gap: 8px;
      margin-bottom: 8px;
    }

    .selector-field {
      flex: 1;
    }

    iframe {
      width: calc(100% - 16px);
      flex: 1;
      border: none;
    }
  `],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatSelect, MatOption, MatFormField, MatLabel, MatIcon, MatSuffix]
})
export class WebviewDialogComponent implements OnInit, OnDestroy {

  url?: SafeUrl;
  selectedClient?: Client;
  languages: string[] = ['en', 'de', 'it'];
  selectedLanguage: string = 'en';
  clients: Client[] = [];
  private boundHandleMessage = this.handleMessage.bind(this);

  constructor(
    public dialogRef: MatDialogRef<WebviewDialogComponent>,
    private readonly sanitizer: DomSanitizer,
    private readonly sessionService: SessionService,
    private readonly httpClient: HttpClient
  ) {
  }

  ngOnInit(): void {
    if (this.sessionService.isAdmin()) {
      this.httpClient.get<Client[]>(environment.API_URL + '/api/client/all').subscribe(clients => {
        this.selectedClient = clients.find(c => c.uuid === this.sessionService.user?.client?.uuid);
        this.clients = clients;
        this.url = undefined;
        this.fetchTokenAndInitIframe();
      });
    } else {
      // TODO: fetch client with api key, this wont work currently
      this.selectedClient = this.sessionService.user?.client;
      this.clients = this.selectedClient ? [this.selectedClient] : [];
      this.url = undefined;
      this.fetchTokenAndInitIframe();
    }

    window.addEventListener('message', this.boundHandleMessage, false);
  }

  fetchTokenAndInitIframe() {
    console.log('fetchTokenAndInitIframe', this.selectedClient?.name);
    this.httpClient.post<{ token: string }>(environment.API_URL + '/api/client/activate/user', {
      externalId: 'test_' + new Date().getTime(),
      test: true,
      language: this.selectedLanguage
    }, {
      headers: {'X-Client-Secret': this.selectedClient!.apiToken}
    }).subscribe(res => {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.WEBVIEW_URL}?token=${res.token}`);
      console.log('this.url', this.url);
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.boundHandleMessage, false);
  }

  handleMessage(event: any) {
    console.log('received message', event);
    if (event.data.type === 'close') {
      this.dialogRef.close();
    }
  }
}
